import React, { ReactNode } from 'react'
import styled from 'styled-components'

import Icon from '../Icon'
import ArrowUp from '../../assets/arrow-up.svg'
import breakpoints from '../../constants/breakpoints'

interface Props {
  goBack: () => void
  children: ReactNode | ReactNode[]
}

const GoBackLink: React.FC<Props> = ({ goBack, children }) => (
  <StyledLink onClick={goBack}>
    <IconContainer>
      <Icon icon={ArrowUp} />
    </IconContainer>
    <Text>{children}</Text>
  </StyledLink>
)

const Text = styled.span`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: inline;
    color: ${({ theme }) => theme.warmGrey};
    font-size: 0.825rem;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 13px;
    transition: all 0.3s ease;
    z-index: -1;
  }
`

const IconContainer = styled.div`
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.warmGrey};
  line-height: 1.5;
  width: 21px;
  height: 21px;
  transition: all 0.3s ease;

  & svg {
    position: relative;
    top: -2px;
    fill: ${({ theme }) => theme.warmGrey};
    width: 9px;
    height: 6px;
  }

  @media (min-width: ${breakpoints.md}) {
    width: 47px;
    height: 47px;
    padding: 12px;
    border-width: 2px;

    & svg {
      top: 0;
      width: 19px;
      height: 12px;
    }
  }
`

const StyledLink = styled.button`
  align-self: center;
  border-radius: 4px;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  position: absolute;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;

  &:hover {
    & > div {
      background-color: ${({ theme }) => theme.blue};
      border-color: ${({ theme }) => theme.blue};
    }

    & span {
      left: 55px;
      opacity: 1;
    }

    svg {
      fill: white;
    }
  }

  &:active {
    outline: none;
  }

  @media (min-width: ${breakpoints.md}) {
    padding: 0;
    top: 19px;
  }
`

export default GoBackLink
